<template>
  <!-- 多选 -->
  <div class="warehouse-project-select-multiple" @click.stop>
    <div class="warehouse-project-select-multiple-main" :class="{'warehouse-project-select-multiple-main-active':isShowOption}" placeholder="请选择" @click="showOption">
      <div class="warehouse-project-select-multiple-main-item" v-for="(item, index) in selectWarehouseAndProject" :key="index">
        <span>{{ item.name }}</span>
        <span class="nums">{{ item.projectIdList.length }}</span>
        <img @click.stop="delSelectWarehouseAndProject(item, index)" class="close-img" src="../../../assets/images/select/close.png">
      </div>
    </div>
    <i class="el-icon-arrow-down" :class="{'arrow-down-active': isShowOption}"></i>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="warehouse-project-option" v-if="isShowOption">
        <!-- 仓库列表 -->
        <div class="option-left">
          <el-checkbox-group
            v-model="checkedWarehouse"
            @change="handleCheckWarehouseChange"
          >
          <div
            class="warehouse-item"
            v-for="(item, index) in warehouseList"
            :key="index"
            :class="{active:index == activeIndex}"
          >
            <el-checkbox
              :label="item.id"
            >
              {{ emptyStr }}
            </el-checkbox>
            <div
              class="warehouse-item-info" 
              @click="selectWarehouse(item, index)">
              <div class="warehouse-item-name" :title="item.name">{{ item.name }}</div>
              <div class="project-nums">{{ item.projectIdList.length }}</div>
            </div>
          </div>
          </el-checkbox-group>
        </div>

        <!-- 项目列表 -->
        <div class="option-right">
          <div class="check-all">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <div class="select-project-nums">
              <span>已选</span>
              <span class="hign-nums">{{ checkedProject.length }}</span>
              <span>个</span>
            </div>
          </div>
          <el-checkbox-group
            v-model="checkedProject"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              v-for="(j, jIndex) in projectList"
              :label="j.id"
              :key="jIndex"
              >
              {{ j.name }}
            </el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import warehouseMixins from "@/common/mixins/warehouse.js";
import projectMixins from "@/common/mixins/project.js";
export default {
  mixins: [warehouseMixins, projectMixins],
  props: ['parentSelectWarehouseAndProject'],
  data() {
    return {
      selectWarehouseAndProject: this.parentSelectWarehouseAndProject,
      isShowOption: false,
      checkAll: false,
      isIndeterminate: true,
      checkedProject: [],
      activeIndex: 0,
      warehouseId: '',
      emptyStr: '',
      checkedWarehouse: []
    };
  },

  async created() {
    await this.initAllWarehouseList()
    this.warehouseId = this.warehouseList.length > 0 ? this.warehouseList[0].id: ''
    this.initWarehouseAndProject()
  },

  mounted() {
    document.body.addEventListener('click', () => {
      this.isShowOption = false;
    }, false);
  },

  methods: {
    initWarehouseAndProject() {
      let checkedWarehouse = []
      this.selectWarehouseAndProject.map(i => {
        this.warehouseList.map(j => {
          if (i.id === j.id) {
            checkedWarehouse.push(i.id)
            j.checkAll = i.checkAll
            j.isIndeterminate = i.isIndeterminate
            j.projectIdList = i.projectIdList
          }
        })
      })
      this.checkedWarehouse = checkedWarehouse
      if (checkedWarehouse.length) {
        let index = this.warehouseList.findIndex(item => { return item.id == checkedWarehouse[0]})
        this.selectWarehouse(this.warehouseList[index], index)
      } else {
        this.selectWarehouse(this.warehouseList[0], 0)
      }
    },

    /**
     * @desc 全选
     */
    handleCheckAllChange(val) {
      let arr = [];
      if (val) {
        this.projectList.map((i) => {
          arr.push(i.id);
        });
      }
      this.checkedProject = arr;
      this.isIndeterminate = false;
      this.setProjectIdList()
    },

    /**
     * @desc 单选
     */
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.projectList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.projectList.length;
      this.checkedProject = value;
      this.setProjectIdList()
    },

    selectWarehouse(row, index) {
      this.activeIndex = index
      this.warehouseId = row.id
      this._getProjectListByWarehouse(this.warehouseId)
      this.checkAll = row.checkAll
      this.isIndeterminate = row.isIndeterminate
      this.checkedProject = row.projectIdList
    },

    /* 选择仓库(勾选) */
    handleCheckWarehouseChange(v) {
      this.getWarehouse(v)
      this.emitParentData()
    },

    getWarehouse(v) {
      let arr = []
      v.map(i => {
        this.warehouseList.map(j => {
          if (i == j.id) arr.push(j)
        })
      })
      this.selectWarehouseAndProject = arr
    },
    
    /**
     * @desc 给仓库设置项目
     */
    setProjectIdList() {
      let row = this.warehouseList[this.activeIndex]
      row.projectIdList = this.checkedProject
      row.checkAll = this.checkAll
      row.isIndeterminate = this.isIndeterminate
      if (this.checkedWarehouse.indexOf(row.id) === -1) {
        this.checkedWarehouse.push(row.id)
      }
      this.getSetSelectWarehouseAndProject()
    },

    /**
     * @desc 获取已设置的仓库和项目
     */
    getSetSelectWarehouseAndProject() {
      this.getWarehouse(this.checkedWarehouse)
      this.emitParentData()
    },

    /**
     * @desc 删除已设置的仓库和项目
     */
    delSelectWarehouseAndProject(row, index) {
      this.warehouseList.map(i => {
        if (i.id === row.id) {
          i.projectIdList = []
          i.checkAll = false
          i.isIndeterminate = true
        }
      })
      let checkedWarehouse = []
      this.checkedWarehouse.map(i => {
        if (i != row.id) {
          checkedWarehouse.push(i)
        }
      })
      this.checkedWarehouse = checkedWarehouse
      this.selectWarehouseAndProject.splice(index,1)
      this.emitParentData()
    },

    emitParentData() {
      this.$emit('getSelectWarehouseAndProject', this.selectWarehouseAndProject)
    },

    showOption() {
      this.isShowOption = !this.isShowOption
    },
  },
};
</script>

<style lang='scss'>
.warehouse-project-select-multiple {
  width: 100%;
  position: relative;
  &-main {
    min-height: 32px;
    max-height: 48px;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid $baseFourSnow;
    box-sizing: border-box;
    padding: 0px 15px;
    cursor: pointer;
    @include flex-start;
    flex-wrap: wrap;
    overflow-y: auto;
    @include scrollbarNotrack(4px);
    transition: all 0.4s;
    &-item {
      height: 24px;
      line-height: 16px;
      font-size: 12px;
      font-family: 'PingFang SC-Regular, PingFang SC';
      font-weight: 400;
      color: $baseGrey;
      box-sizing: border-box;
      padding: 4px 5px 4px 8px;
      border-radius: 3px 3px 3px 3px;
      background: $baseThreeSnow;
      margin: 4px 8px 4px 0px;
      .nums {
        height: 16px;
        line-height: 16px;
        padding: 0px 8px 0px 9px ;
        background: $baseThreeGrey;
        border-radius: 8px 8px 8px 8px;
        font-size: 12px;
        font-family: 'PingFang SC-Medium, PingFang SC';
        font-weight: 800;
        color: $baseGrey;
        margin-left: 6px;
      }
      .close-img {
        width: 16px;
        height: 16px;
        margin-left: 2px;
        margin-bottom: 3px;
      }
    }
  }
  &-main:empty::before {
    height: 30px;
    line-height: 30px;
    color: $baseThreeGrey;
    content: attr(placeholder);
  }
  &-main-active {
    border-color: $baseBlue;
    transition: all 0.4s;
  }
  .el-icon-arrow-down {
    position: absolute;
    top: 30%;
    right: 15px;
    transition: all 0.4s;
  }
  .arrow-down-active {
    transform: rotate(180deg);
  }
  .warehouse-project-option {
    width: 100%;
    position: absolute;
    margin-top: 10px;
    z-index: 6;
    @include flex-start;
    height: 232px;
    border: 1px solid $baseFourSnow;
    border-radius: 3px;
    background: white;
    box-sizing: border-box;
    box-shadow: 0px 5px 10px 1px rgba(0,0,0,0.08);
    .option-left {
      width: 149px;
      height: 100%;
      padding: 8px 8px 8px 9px;
      box-sizing: border-box;
      // @include flex-column-start;
      overflow-y: auto;
      @include scrollbarNotrack(4px);
      .warehouse-item {
        width: 100%;
        height: 40px;
        padding: 0px 8px;
        margin-right: 0px;
        margin-bottom: 4px;
        box-sizing: border-box;
        @include flex-start;
        cursor: pointer;
        &:hover {
          border-radius: 3px;
          background: $selectHoverBg;
          .project-nums {
            height: 16px;
            line-height: 16px;
            padding: 0px 8px 0px 9px ;
            background: $selectProjectBg;
            border-radius: 8px 8px 8px 8px;
            font-size: 12px;
            font-family: 'PingFang SC-Heavy, PingFang SC';
            font-weight: 800;
            color: #FFFFFF;
          }
        }
        .el-checkbox__label {
          padding: 0px;
        }
        .warehouse-item-info {
          flex: 1;
          padding-left: 4px;
          @include flex-between;
          box-sizing: border-box;
        }
        .warehouse-item-name {
          flex: 1;
          width: 62px;
          margin-right: 4px;
          font-size: 14px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseGrey;
          box-sizing: border-box;
          @include two-wrap-ellipsis(1);
        }
        .project-nums {
          height: 16px;
          line-height: 16px;
          padding: 0px 8px 0px 9px ;
          background: $baseThreeSnow;
          border-radius: 8px 8px 8px 8px;
          font-size: 12px;
          font-family: 'PingFang SC-Heavy, PingFang SC';
          font-weight: 800;
          color: $baseThreeGrey;
        }
      }
      .active {
        border-radius: 3px;
        background: $selectHoverBg;
        .project-nums {
          height: 16px;
          line-height: 16px;
          padding: 0px 8px 0px 9px ;
          background: $selectProjectBg;
          border-radius: 8px 8px 8px 8px;
          font-size: 12px;
          font-family: 'PingFang SC-Heavy, PingFang SC';
          font-weight: 800;
          color: #FFFFFF;
        }
      }
    }
    .option-right {
      flex: 1;
      height: 100%;
      border-left: 1px solid $baseThreeSnow;
      @include flex-column-start;
      .check-all {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0px 8px;
        box-sizing: border-box;
        @include flex-between;
        border-bottom: 1px solid $baseThreeSnow;
        .el-checkbox__label {
          font-size: 14px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseGrey;
        }
        .select-project-nums {
          font-size: 12px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseThreeGrey;
          .hign-nums {
            display: inline-block;
            color: $baseGrey;
            padding: 0px 6px;
            font-weight: 800;
          }
        }
      }
      .el-checkbox-group {
        flex: 1;
        width: 100%;
        padding: 0px 8px;
        box-sizing: border-box;
        overflow-y: auto;
        @include scrollbarNotrack(4px);
        @include flex-column-start;
        .el-checkbox {
          @include flex-start;
          margin-right: 0px;
          .el-checkbox__label {
            width: 262px;
            height: 40px;
            line-height: 38px;
            overflow : hidden;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
